// /src/pages/PrivacyPage.jsx

import React from 'react';
import PublicLexicalPage from '../components/PublicLexicalPage';

function PrivacyPage() {
  return (
    <PublicLexicalPage 
      documentName="Privacy"
      layout="classic"
    />
  );
}


export default PrivacyPage;
